import type { CSSProperties } from 'react';

interface LogoProps {
  variant?: 'full' | 'mark';
  color?: 'light' | 'dark';
  style?: CSSProperties;
  className?: string;
  title?: string;
  white?: boolean;
}

/**
 * SETU logo component.
 * - mark: just the SETU wordmark with red swoosh + pin
 * - full: wordmark with optional "tagline" beside
 *
 * The wordmark re-creates the brand mark from logo.png using inline SVG:
 *  • Stylized "SETU" letters in navy
 *  • Red swoosh/arc threading under and over the letters
 *  • Red location pin on top
 */
export default function Logo({
  variant = 'full',
  color = 'dark',
  style,
  className,
  title = 'SETU',
  white = false,
}: LogoProps) {
  const imgFilter = white ? {
    filter: 'invert(1)',
  } : {};
  if (variant === 'mark') {
    return (
      <img
        src="/logo.png"
        alt={title}
        style={{ height: 44, width: 'auto', ...imgFilter, ...style }}
        className={className}
      />
    );
  }

  return (
    <div className={className} style={{ display: 'inline-flex', alignItems: 'center', gap: 12, ...style }}>
      <img
        src="/logo.png"
        alt={title}
        style={{ height: 48, width: 'auto', ...imgFilter, background: 'transparent' }}
      />
      <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1 }}>
        <span
          style={{
            fontFamily: 'Sora, Inter, sans-serif',
            fontWeight: 800,
            fontSize: '1.4rem',
            color: color === 'light' ? '#ffffff' : '#1a2849',
            letterSpacing: '-0.02em',
          }}
        >
          SETU
        </span>
        <span
          style={{
            fontSize: '0.7rem',
            fontWeight: 500,
            color: color === 'light' ? 'rgba(255,255,255,0.7)' : 'var(--color-gray-500)',
            letterSpacing: '0.1em',
            textTransform: 'uppercase',
            marginTop: 2,
          }}
        >
          Emergency Bridge
        </span>
      </div>
    </div>
  );
}
